export const ProfileTabsNames = ["About", "Posts", "Overview", "Opportunities", "Links", "Portfolio", "People"];
